import { useState } from 'react';
import { format } from 'date-fns';
import { Calendar } from "@/components/ui/calendar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { usePrograms } from '../hooks/usePrograms';

export function OutreachCalendar() {
  const [date, setDate] = useState<Date>(new Date());
  const { data: programs } = usePrograms();

  const programsOnDate = programs?.filter(program => {
    const startDate = new Date(program.startDate);
    const endDate = new Date(program.endDate);
    return date >= startDate && date <= endDate;
  });

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-foreground">Program Calendar</h1>
      </div>

      <div className="grid gap-6 lg:grid-cols-[300px,1fr]">
        <Card className="border-0 shadow-md h-fit">
          <CardHeader className="border-b bg-muted/50">
            <CardTitle className="text-foreground">Calendar</CardTitle>
          </CardHeader>
          <CardContent className="p-4">
            <Calendar
              mode="single"
              selected={date}
              onSelect={(date) => date && setDate(date)}
              className="rounded-md border"
            />
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardHeader className="border-b bg-muted/50">
            <CardTitle className="text-foreground">
              Programs on {format(date, 'MMMM d, yyyy')}
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            {programsOnDate?.length ? (
              <div className="space-y-4">
                {programsOnDate.map((program) => (
                  <div
                    key={program.id}
                    className="flex items-center justify-between p-4 rounded-lg border bg-card"
                  >
                    <div>
                      <h3 className="font-medium text-foreground">{program.name}</h3>
                      <p className="text-sm text-muted-foreground">
                        {program.location.name}
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <Badge>{program.type}</Badge>
                      <Badge variant="outline">{program.status}</Badge>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-muted-foreground">No programs scheduled for this day</p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
